import { Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import { ContentDeliveryAssemblyType, IDeliveryAssemblySection, ISectionDescriptionItem, PlainHtmlType } from '@features/productPreview/sections/ProductDescription/typescript';
import ProductDescriptionItem from '@features/productPreview/sections/ProductDescription/components/ProductDescriptionBlock/ProductDescriptionItem';
import styles from '@features/productPreview/sections/ProductDescription/ProductDescription.styles';
import ProductPreviewPageState from '@features/productPreview/mobX/state/ProductPreviewPageState';
import VideoCollection from '@features/productPreview/sections/VideoCollection/VideoCollection';
import sanitizeHtml from '@utils/sanitizeHtml';
import { WindowType } from '@typescript/index';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
type PropsType = {
  items: ISectionDescriptionItem[];
  windowType: WindowType;
  state: ProductPreviewPageState;
};
const isDeliveryType = (item: ISectionDescriptionItem): item is IDeliveryAssemblySection => (item as IDeliveryAssemblySection).descriptionCode === 'PRODUCT_DELIVERY_ASSEMBLY';
const DeliverySection = ({
  items,
  windowType,
  state
}: PropsType) => <>
    {items.map((item: ISectionDescriptionItem) => {
    const {
      title
    } = item;
    let details: React.ReactNode | null = <div dangerouslySetInnerHTML={sanitizeHtml(item.content as PlainHtmlType)} sx={styles.productContainerContent} />;
    let delivery: React.ReactNode | null = null;
    if (isDeliveryType(item)) {
      delivery = item.content.map((deliveryItem: ContentDeliveryAssemblyType) => {
        const contentText = <div dangerouslySetInnerHTML={sanitizeHtml(deliveryItem.item)} sx={styles.productContainerContent} />;
        return <div key={deliveryItem.title} sx={styles.productDescriptionDeliveryContainer}>
              <Heading h={5} headingType={5} size={16} pb={24} bold color={theme.rawColors.neutralBlack}>
                {deliveryItem.title}
              </Heading>
              {contentText}
              {deliveryItem.title === 'Montaż' && <VideoCollection video={item.video} classNames={styles.videoStyles} state={state} />}
            </div>;
      });
      details = null;
    }
    return <Fragment key={item.descriptionCode}>
          <div sx={styles.descriptionContainer}>
            <ProductDescriptionItem title={title || ''} windowType={windowType} isExpanded={state.deliveryOpen}>
              <>
                {details}
                <div sx={styles.productDescriptionDelivery}>{delivery}</div>
              </>
            </ProductDescriptionItem>
          </div>
        </Fragment>;
  })}
  </>;
export default observer(DeliverySection);